/**
 * Метка состояния: цветная точка и подпись.
 *
 * Отдельным компонентом, потому что состояние подключения показывается в
 * четырёх местах — в карточке чата, в списке аккаунтов, в панели подключения и
 * в боковой колонке. Четыре набора классов разошлись бы, и один и тот же
 * аккаунт выглядел бы на разных экранах по-разному.
 */

import { connectionLabel, connectionTone } from "../lib/labels.js";
import { cn } from "@/lib/utils";

interface StateBadgeProps {
  state: string;
  className?: string;
}

export function StateBadge({ state, className }: StateBadgeProps) {
  const ok = connectionTone(state) === "ok";

  return (
    <span
      className={cn(
        "inline-flex flex-none items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-medium",
        ok
          ? "bg-[var(--ok)]/12 text-[var(--ok)]"
          : "bg-secondary text-muted-foreground",
        className,
      )}
    >
      <span
        aria-hidden
        className={cn(
          "size-1.5 rounded-full",
          ok ? "bg-[var(--ok)]" : "bg-muted-foreground",
        )}
      />
      {connectionLabel(state)}
    </span>
  );
}
